var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"container",on:{"click":_vm.click}},[_c('router-link',{staticClass:"link",attrs:{"id":"logo","to":"/"}},[_vm._v("ESTABLISHED.")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }